import { useState } from "react";
import { HiOutlineSpeakerWave } from "react-icons/hi2";
import { IoCall } from "react-icons/io5";
import Groups from "./ChatTabs/Group";
import { FaUserGroup } from "react-icons/fa6";
import { GoArrowLeft } from "react-icons/go";
import { BsSendFill } from "react-icons/bs";
import { IoSettingsOutline } from "react-icons/io5";
import { IoSearch } from "react-icons/io5";
import Staff from "./ChatTabs/Staff";
import profile from "../../../src/Assets/Images/Profile.png";
import { useGlobalContext } from "../../Context/GlobalContext";
import Admin from "./ChatTabs/Admin";
import { timeSince } from "../../utils/helper";
import ChatComponent from "../../components/ChatComponent";
import Loader from "../../components/Loader";
import { NavLink } from "react-router-dom";

const StaffChatInterface = () => {
  const {
    setSelectedUser,
    messages,
    fetchOneOnOneChat,
    selectedUser,
    setMessages,
    message,
    setMessage,
    sendMessage,
    showChatSection,
    setShowChatSection,
    id,
    setId,
    handleSelectedUser,
    isSendingMessage,
  } = useGlobalContext();
  const [chatTab, setChatTab] = useState("admins");

  return (
    <div class="overflow-hidden">
      <div class="flex bg-white shadow-cs shadow-lg m-[10px] p-[10px] rounded-lg h-[calc(100vh-80px)] parent-container">

        <div
          className={`w-full ${showChatSection ? "hidden sm:block" : "block"} md:w-1/3 flex flex-col border-r-2 h-full bg-white overflow-hidden`}

        >
          <div className="flex flex-row justify-start items-center space-x-3 mb-2 pb-5 border-b">
            <div className="border-[#24007a] p-[2px] border rounded-full">
              <img src={profile} alt="" className="rounded-full w-9 h-9" />
            </div>
            <p className="font-medium text-xl">Kanika Arora</p>
          </div>
          {/* <!-- Search Bar --> */}
          <div class="relative flex items-center border-gray-300 bg-white shadow-lg mt-[10px] mr-[10px] border rounded-[10px]">
            <input
              type="text"
              placeholder="Search members..."
              class="bg-transparent py-[10px] pl-2 w-full font-normal text-sm outline-none"
            />
            <IoSearch className="right-0 absolute mt-1 pr-2 text-[30px] text-gray-400" />
          </div>

          {/* <!-- Member List --> */}
          <div className="flex flex-col flex-grow px-3 pr-[0px] pl-[0px] h-full overflow-y-auto">
            <div className="grid grid-cols-3 mt-[10px] mb-4 w-full md:w-[80%]">
              <NavLink
                className={`flex justify-center items-center rounded-[10px] p-3 ${chatTab === "admins" ? "text-[#24007a] " : "text-gray-400 hover:text-black"
                  }`}
                onClick={() => {
                  setChatTab("admins");
                }}
              >
                Admins
              </NavLink>
              <NavLink
                className={`flex justify-center items-center rounded-[10px] p-3 ${chatTab === "groups" ? "text-[#24007a] " : "text-gray-400 hover:text-black"
                  }`}
                onClick={() => {
                  setChatTab("groups");
                }}
              >
                Groups
              </NavLink>
            </div>

            {chatTab === "admins" ? (
              <Admin handleSelectedUser={handleSelectedUser} />
            ) : (
              <Groups />
            )}


            {/* member column in ChatSection */}
          </div>
        </div>
        {/* <!-- Right Section: Chat Window --> */}

        <div className={`md:w-2/3  md:flex flex-col flex-grow ${showChatSection ? "block sm:block" : "hidden sm:block"
          } chat-section`}>
          {!showChatSection && (
            <div className="flex justify-center items-center h-full">
              <p className="font-semibold text-gray-400 text-lg">
                Select a user to start chatting
              </p>
            </div>
          )}
          {showChatSection && (
            <div className="flex flex-col h-full">
              <div className="flex justify-between items-center mt-5 md:mt-0 mb-4 pb-[6px] border-b">
                <div className="relative flex flex-row justify-start items-center space-x-3 rounded-[100%] w-[70%] md:w-[50%]">
                  <div
                    className="float-left"
                    onClick={() => {
                      setShowChatSection(false);
                    }}
                  >
                    <GoArrowLeft className="size-5" />
                  </div>
                  <div className="flex justify-center items-center border-gray-300 bg-purple-400 shadow-lg px-4 py-2 border rounded-full">
                    {/* <img
                    src={staff.imgSrc}
                    className="w-10 h-10"
                    alt={staff.name}
                  /> */}
                    {selectedUser.name[0]}
                  </div>
                  <div className="flex flex-col">
                    <h2 className="mt-2 font-normal text-md">
                      {selectedUser.name}
                    </h2>
                    <p className="text-gray-300 text-sm">
                      last seen 3 hours ago
                    </p>
                  </div>
                </div>
                <div className="flex space-x-2">
                  <HiOutlineSpeakerWave className="w-[30px] h-[30px] text-purple-600" />
                  <IoCall className="w-[25px] h-[30px] text-purple-600" />
                </div>
              </div>
              <ChatComponent messages={messages} />
              <div className="flex items-center mt-4 rounded-xl">
                <div class="relative w-[96%]">
                  <input
                    type="text"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Send Message..."
                    class="p-2 pr-10 border rounded-lg w-full"
                  />
                  <div class="right-0 absolute inset-y-0 flex items-center pr-3">
                    <IoSettingsOutline className="text-2xl text-gray-500" />
                  </div>
                </div>
                <button
                  onClick={sendMessage}
                  disabled={isSendingMessage}
                  className={`bg-purple-500 text-white flex justify-center items-center p-2 py-3 rounded-xl w-[4%] ${isSendingMessage && "opacity-50"
                    }`}
                >
                  <BsSendFill />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StaffChatInterface;
